import error from '../utils/error'

import {
  PROMISE_PENDING,
  PROMISE_FULFILLED,
  PROMISE_REJECTED,
  SLIDER_HOME
} from '../constants'

const initialState = {
  images:[],
  isFetch:false,
  error:null
}

const getImageSlider = (state, payload) => {
  let newState = {...state}
  newState.images = [...payload.data]
  newState.isFetch = false
  newState.error = null
  return newState
}

const sliderImageReducer = (state=initialState, actions) => {
  switch (actions.type) {
    case `${SLIDER_HOME}${PROMISE_PENDING}`: return {...state, isFetch: true, error: null}
    case `${SLIDER_HOME}${PROMISE_FULFILLED}`: return getImageSlider(state, actions.payload)
    case `${SLIDER_HOME}${PROMISE_REJECTED}`: return {...state, isFetch: false, error: true}
    default: return state
  }
}

export default sliderImageReducer